import { Text, View } from "@react-pdf/renderer";
import TaxGuideStyles from "./TaxGuideStyles";

const Header = ({ primaryColor, tradingName }) => {
  const styles = TaxGuideStyles(primaryColor || "081e56");
  const currentYear = 2025;
  const nextYear = 2026;
  return (
    <View style={styles.pageHeader} fixed>
      <Text style={styles.pageHeaderText}>
        Tax Guide 2026/27
      </Text>
      <Text
        style={styles.pageHeaderText}
        render={({ pageNumber, totalPages }) => `Page ${pageNumber}`}
      />
    </View>
  );
};

export default Header;
